export const sortingMethods = {
    PRICE_INCREASING: {
        key: "PRICE_INC",
        value: 1,
        title: "Price increasing"
    },

    PRICE_DECREASING: {
        key: "PRICE_DEC",
        value: 2,
        title: "Price decreasing"
    },
    DATE_ADDED_NEWEST: {
        key: "DATE_ADDED_NEWEST",
        value: 3,
        title: "Newest"
    },
    DATE_ADDED_OLDEST: {
        key: "DATE_ADDED_OLDEST",
        value: 4,
        title: "Oldest"
    },
    BUILD_YEAR_NEWEST: {
        key: "BUILD_YEAR_NEWEST",
        value: 5,
        title: "Build year newest",
    },
    BUILD_YEAR_OLDEST: {
        key: "BUILD_YEAR_OLDEST",
        value: 6,
        title: "Build year oldest"
    }

}